<ng-container *ngIf="mode === 'TEXT_MODE'; else dropdownMode">
  <div>{{ plainText }}</div>
</ng-container>
<ng-template #dropdownMode>
  <nv-dropdown [options]="options" [selected]="selected" [isInverted]="true" (selectOption)="onSelect($event)">
  </nv-dropdown>
</ng-template>
